import { useEffect } from 'react';
import useHasAcknowledgedTerms from '../useHasAcknowledgedTerms';
import useModal from 'src/components/Modals/hooks/useModal';
import useWalletIsConnected from '../useWalletIsConnected';
import { usePrivateBetaWalletWhitelistStatus } from 'src/hooks/privateBetaWalletWhitelist/usePrivateBetaWalletWhitelistStatus';

export const useOnboardingFlowControl = () => {
	const connected = useWalletIsConnected();
	const [hasAcknowledgedTerms] = useHasAcknowledgedTerms();
	const { currentModal, show } = useModal();
	const { hasAccess, isLoading, isPrivateBetaWhitelistEnabled } =
		usePrivateBetaWalletWhitelistStatus();

	useEffect(() => {
		if (!connected) {
			return;
		}

		if (currentModal?.type === 'connect_wallet') {
			return;
		}

		if (isPrivateBetaWhitelistEnabled && (isLoading || !hasAccess)) {
			return;
		}

		const shouldShowTerms = hasAcknowledgedTerms.shouldShowTermsReminder;

		if (shouldShowTerms && currentModal?.type !== 'terms_of_use') {
			show({ type: 'terms_of_use', props: {} });
		}
	}, [
		connected,
		hasAccess,
		hasAcknowledgedTerms.shouldShowTermsReminder,
		currentModal?.type,
		isLoading,
		isPrivateBetaWhitelistEnabled,
		show,
	]);
};
